import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { Header } from '@hz-design-system/web-ui';

import '../../../scss/global.scss';

export default () => {
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRootContainer = document.getElementById('header-root');

  // Header is server side rendered in express-react library
  // todo: Add I18nContext wrapper here and in express-react as well
  hydrateRoot(headerRootContainer!, <Header headerConfig={headerConfig} />);
};
